import { render, staticRenderFns } from "./totalList.vue?vue&type=template&id=a9eddcde&scoped=true"
import script from "./totalList.vue?vue&type=script&lang=js"
export * from "./totalList.vue?vue&type=script&lang=js"
import style0 from "./totalList.vue?vue&type=style&index=0&id=a9eddcde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9eddcde",
  null
  
)

export default component.exports